import { Code } from './Code';
export function isCode(node) {
    return node !== null && typeof node === 'object' && node instanceof Code;
}
export default isCode;    //# sourceMappingURL=isCode.js.map
